const URL_API = 'https://www.didayz.com:8081';
const isFromPhone = window.innerWidth < 768 ? true : false;

export { URL_API, isFromPhone }